module.exports = __webpack_public_path__ + "img/img44.b6d73048.jpg";